package fr.frux.feature.treedetail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/**
 * Contrat de fabrique du [TreeDetailViewModel], honoré par le composition root (#43).
 *
 * `treeId` vient de la route, pas du graphe : c'est le seul paramètre que l'appelant fournit.
 */
fun interface TreeDetailViewModelFactory {
    fun create(treeId: Long): TreeDetailViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalTreeDetailViewModelFactory = staticCompositionLocalOf<TreeDetailViewModelFactory> {
    error("TreeDetailViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
}

/** Fabrique le TreeDetailViewModel depuis la fabrique fournie par le root. */
@Composable
fun rememberTreeDetailViewModel(treeId: Long): TreeDetailViewModel {
    val factory = LocalTreeDetailViewModelFactory.current
    return viewModel { factory.create(treeId) }
}
